export interface InformationProps {
  property: any;
}
export default function Information(props: InformationProps) {
  return (
    <div className="bg-white py-6 px-4 sm:px-6 lg:py-12 lg:px-8">
      <div className="relative max-w-lg mx-auto lg:max-w-7xl">
        <div className="text-left">
          <h2 className="text-xl tracking-tight font-semibold text-gray-900 sm:tracking-tight">
            Information
          </h2>
          <p className="mt-2 text-base text-gray-500 sm:mt-4">
            {props.property.description}
          </p>
        </div>
      </div>
      <div className="relative mt-8 pb-8 max-w-lg mx-auto lg:max-w-7xl border-b">
        <div className="text-left">
          <h2 className="text-xl tracking-tight font-semibold text-red-600 sm:tracking-tight">
            Note:
          </h2>
          <p className="mt-2 text-base text-red-500 sm:mt-4">
            The interested buyers are bound by the principle of caveat emptor
            (the principle that the buyer alone is responsible for checking the
            quality and suitability of goods before a purchase is made).
          </p>
        </div>
      </div>
    </div>
  );
}
